import React, { Fragment } from 'react';
import personalaccess from '../../../../../images/ParkingLots/Instructions/SF/entry1.jpeg';
import personalaccess2 from '../../../../../images/ParkingLots/Instructions/SF/entry2.png';
import machine from '../../../../../images/ParkingLots/Instructions/SF/parkingmachine.jpeg';
import '../../driverFaq.css';

const PersonalVehicleAccess = () => (
  <Fragment>
    <div
      style={{
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px'
      }}>
      <img src={personalaccess} className="personal-image" />
      <img src={personalaccess2} className="personal-image" />
    </div>
    <br />
    <p>
      You can enter/exit the parking lot via Davis St or Drumm St. Tap the
      parking keycard attached to the Autzu vehicle sun visor to enter and
      exit the parking lot. Head to level A and follow the Autzu signage to
      locate your Autzu EV.
    </p>
    <br />
    <div
      style={{
        textAlign: 'center',
        width: '100%'
      }}>
      <img src={machine} style={{ width: '400px', height: '450px' }} />
    </div>
    <br />
    <p>
      We do not currently offer free public parking for those who drive a
      personal vehicle to our hub. Please pay for parking if you are
      driving your personal vehicle to our location.
    </p>
    <br />
  </Fragment>
);

export default PersonalVehicleAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Embarcadero/PersonalVehicleAccess.js